import { StatusEquipamento } from "./StatusEquipamento";

export default StatusEquipamento;